export default "__VITE_ASSET__B1NHH8u4__ 584w";